var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"space-between-y"},[(_vm.vo.examine === 'APPROVED')?_c('el-alert',{attrs:{"title":"审核通过","type":"success","description":"审核通过，家长可以对需求自行进行发布"}}):_vm._e(),(_vm.vo.examine === 'REJECTED')?_c('el-alert',{attrs:{"show-icon":"","title":"审核驳回","type":"error","description":_vm.vo.examineErrMsg}}):_vm._e(),(_vm.vo.examine === 'PENDING')?_c('el-alert',{attrs:{"show-icon":"","title":"未审核","type":"warning","description":"未审核期间，家长的需求发布受限"}}):_vm._e(),_c('info',{attrs:{"infos":[
      {label:'ID',value:_vm.vo.id},
      {label:'标题',value:_vm.vo.name},
      {label:'描述',value:_vm.vo.desc},
      {label:'价格',value:_vm.vo.price},
      {label:'教师姓名',value:_vm.vo.teacherName},
      {label:'审核状态',value:_vm.vo.examine}
  ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }